import { render, staticRenderFns } from "./cargolist.vue?vue&type=template&id=6e8fe588&scoped=true&"
import script from "./cargolist.vue?vue&type=script&lang=js&"
export * from "./cargolist.vue?vue&type=script&lang=js&"
import style0 from "./cargolist.vue?vue&type=style&index=0&id=6e8fe588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8fe588",
  null
  
)

export default component.exports